import { ENV_CONFIG } from 'constants/environment';

export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || ENV_CONFIG().API_BASE_URL;

export const VALUATION_DATES_API = 'valuationDatesApi';
export const FUNDS_LIST_API = 'fundsApi';
export const BENCHMARK_LIST_API = 'benchmarkApi';
export const POSITIONS_API = 'positionsApi';
export const MEASURES_API = 'measuresApi';
export const MARKET_DATA_API = 'marketDataApi';
export const METRICS_API = 'metricsApi';
export const REPORT_CONFIGS_API = 'reportConfigsApi';
export const APP_CONTEXT_API = 'appContextApi';
export const APP_JOBS_API = 'appJobsApi';
export const APP_PORTFOLIOS_API = 'appPortfoliosApi';
export const REPORTS_DATA_API = 'reportsDataApi';
export const CONFIGS_API = 'configsApi';

export enum HttpStatusCode {
  OK = 200,
  CREATED = 201,
  ACCEPTED = 202,
  NO_CONTENT = 204,

  FOUND = 302,
  NOT_MODIFIED = 304,

  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,

  INTERNAL_SERVER_ERROR = 500,
  NOT_IMPLEMENTED = 501,
  BAD_GATEWAY = 502,
  SERVICE_UNAVAILABLE = 503,
}
